import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessService } from 'app/core/access/access.service';
import { UserService } from 'app/core/user/user.service';
import { catchError, map, of } from 'rxjs';

export const accessGuard = (menuId: string): CanActivateFn => {
    return () => {
        const accessService = inject(AccessService);
        const userService = inject(UserService);
        const router = inject(Router);

        const evaluateAccess = () =>
            accessService.canRead(menuId)
                ? true
                : router.createUrlTree(['/access-denied']);

        if (accessService.isLoaded()) {
            return evaluateAccess();
        }

        return userService.getMenuByUser().pipe(
            map((menuItems) => {
                accessService.load(menuItems);
                return evaluateAccess();
            }),
            catchError(() => of(router.createUrlTree(['/access-denied'])))
        );
    };
};
